module.exports = __webpack_public_path__ + "img/sh-img3.fb96faed.png";